import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Input, message, Row, Spin } from 'antd';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import { useNavigate, useParams } from 'react-router-dom';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import { TEACHER_URL } from '../../api/URLs';
import _ from 'lodash';
import HeaderTeacherComponent from '../header/HeaderTeacherComponent';
import UploadTeacherComponent from '../upload/UploadTeacherComponent';
import DragUploadTeacherComponentVideo from '../upload/DragUploadTeacherComponentVideo';
import TextAreaComponent from '../input/TextAreaComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';



function TeacherUpload() {
    const { t } = useTranslation();
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const { id } = useParams();
    const [picUrl, setpicUrl] = useState("")
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [dataObject, setDataObject] = useState({
        name: "",
        textIntro: "",
        picUrl: "",
        videoIntro: "",
        privateFile: {
            url: "",
            size: "",
            fileName: "",
            duration: ""
        }
    });
    const [privateFile, setPrivateFiles] = useState([]);

    const addNewValue = async (data) => {
        setpicUrl(data.picUrl);
        let objectValue = {
            ...dataObject,
            name: data.name,
            textIntro: data.textIntro,
            picUrl: data.picUrl,
            videoIntro: data.videoIntro,
            privateFile: {
                url: data?.videoIntro ?? "",
                size: data?.videoSize ?? "",
                fileName: data?.videoName ?? "",
                duration: data?.videoDuration ?? "",
            }
        };

        setDataObject({
            ...objectValue,
        })

        setPrivateFiles([{
            "url": data?.videoIntro ?? "",
            "size": data?.videoSize ?? "",
            "name": data?.videoName ?? "",
            "uid": data?.uploadedTS || new Date(),
            duration: data?.videoDuration ?? "",
        }]);
    }

    const getDetailById = async () => {
        if (!id) { return; }
        setLoading(true);
        await getDataRequest(`${TEACHER_URL}/${id && id}`)
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    addNewValue(res.data)
                }
            })
            .catch(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        id && getDetailById()
    }, [id])

    const checkError = () => {
        if (
            !dataObject.name ||
            !dataObject.picUrl ||
            !dataObject?.privateFile?.url
        ) {
            return true
        }
        return false
    }

    const insertParams = () => {
        return {
            "name": dataObject.name,
            "textIntro": dataObject.textIntro,
            "picUrl": dataObject.picUrl, // cover
            "videoIntro": dataObject.privateFile?.url,
            "videoSize": dataObject.privateFile?.size,
            "videoName": dataObject.privateFile?.fileName,
            videoDuration: dataObject.privateFile?.duration
        }
    }
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        const params = insertParams()
        try {
            const res = await postDataRequest(TEACHER_URL, params);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(t(res?.message) || t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate(`/education-course`)
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err && err.message || t("Server Error!"), () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const hadleUpdate = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        let params = insertParams();
        try {
            if (!_.isEmpty(params)) {
                const res = await putDataRequest(`${TEACHER_URL}/${id}`, params);
                if (res?.status === 200) {
                    messageModalRef.current.showSuccessConfirmsAutoClose(t(res.message) || t("Saved Successfully"), () => { }, "", true);
                    setTimeout(() => {
                        navigate(`/education-course`)
                    }, 2000);
                } else {
                    messageModalRef.current.showWarningConfirmsAutoClose(res.message || res.message || t("An error occurred."), () => { }, "", true);
                }
            } else {
                messageModalRef.current.showSuccessConfirmsAutoClose(t("No changes to Data!"), () => { }, "", true);
                setTimeout(() => {
                    navigate(`/education-course`)
                }, 2000);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err && err.message || t("Server Error!"), () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const handleChangeValue = (e) => {
        setDataObject((v) => ({ ...v, [e.target.name]: e.target.value ?? "" }));
    }

    const handleChangePrivateFile = (value) => {
        setPrivateFiles(value);
        setDataObject((v) => ({
            ...v,
            privateFile: {
                "url": value[0]?.url ?? "",
                "size": value[0]?.size ?? "",
                "fileName": value[0]?.name ?? "",
                duration: value[0]?.duration ?? ""
            }
        }));
    }

    const handleChangeCover = (value) => {
        setpicUrl(value.url)
        setDataObject((v) => ({
            ...v,
            picUrl: value.url
        }));
    }


    return (
        <>
            <HeaderTeacherComponent
                backgroundColor="#E50A47"
                border="1px solid #e72158"
                isHide="view"
                onClick={() => navigate('/education-course')}
                backTitle={t("Create a Teacher")}
                hideTitle="userDetails"
                bntTitle1={t("Submit")}
                opacity="0.5px"
                color="#FFFFFF"
                onClick1={() => {
                    !id ? handleSubmit() : hadleUpdate();
                }}
            >
                <Spin spinning={loading} fullscreen></Spin>
                <div className='container newDetail'>
                    <Row>
                        <Col md={5}>
                            <OSSUploadWrapper
                                onUploadSuccess={handleChangeCover}
                            >
                                <UploadTeacherComponent
                                    fileList={picUrl ? [{
                                        "uid": "1",
                                        "name": "",
                                        "status": "done",
                                        "url": picUrl
                                    }] : []}
                                    uploadavatarTitle={t("Upload Teacher Photo")}
                                    changeAvatarTitle={t("Update teacher photo")}
                                    setFileList={handleChangeCover}
                                />
                            </OSSUploadWrapper>
                        </Col>
                        <Col md={19}>
                            <Row>
                                <Card className='w-100'>
                                    <OSSUploadWrapper
                                        onUploadSuccess={(result) => {
                                            handleChangePrivateFile([result]);
                                        }}
                                    >
                                        <DragUploadTeacherComponentVideo
                                            privateFile={true}
                                            // previewUrl={picUrl}
                                            fileList={privateFile}
                                            setFileList={handleChangePrivateFile}
                                            maxSize={50}
                                        />
                                    </OSSUploadWrapper>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Teacher Name')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <Input
                                                value={dataObject.name}
                                                placeholder=""
                                                size="large"
                                                name='name'
                                                status={isSubmit && !dataObject.name && `error`}
                                                onChange={handleChangeValue}
                                                style={{
                                                    width: "100%"
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('introduce')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <TextAreaComponent status={isSubmit && !dataObject.textIntro ? "error" :""} value={dataObject.textIntro} setValue={(value) => setDataObject({ ...dataObject, textIntro: value })} />
                                        </Col>
                                    </Row>
                                </Card>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </HeaderTeacherComponent>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
}

export default TeacherUpload;